import roneo from "roneo";
import domready from "domready";
import viewloader from "viewloader";
import views from "./views";
import { setupAppsignal } from "../../../main/assets/public/appsignal";

try {
  setupAppsignal("admin");
} catch (e) {
  console.error(e);
}

let viewloaderManager = viewloader(views);

/**
 * Kick roneo immediately
 */

roneo();

/**
 * Kick things off on domReady
 */
domready(function onDomready() {
  viewloaderManager.callViews();
});

document.addEventListener("turbolinks:render", function onTurboLinksLoad() {
  viewloaderManager.callViews();
});

document.addEventListener(
  "turbolinks:before-render",
  function onTurboLinksBeforeRender() {
    viewloaderManager.destroyViews();
  }
);
